import { ConfirmationCodeMethod } from "../@types/ConfirmationCode";
import { createPhoneCode } from "../services/confirmation-codes";

export default function useConfirmationCode() {
  function createOne(
    phone: string,
    method: ConfirmationCodeMethod
  ): Promise<string> {
    const onlyDigitsPhone = phone.replace(/[^0-9]/g, "");

    return createPhoneCode(onlyDigitsPhone, method);
  }

  return {
    createPhoneCode: createOne,
  };
}
